import type { FC } from 'react';
import React, { useState } from 'react';
import { ResizableBox } from 'react-resizable';
import { useIsomorphicLayoutEffect } from '@isomorphic/hooks/use-isomorphic-layout-effect';
import { StyledResizableAside } from './ResizableAside.styles';
import { useResizer } from '../../hooks/use-resizer';

export const initialWidth = 0;
export const defaultWidth = 300;

export const ResizableAside: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const maxWidth = 560;
  const defaultHeight = 100;
  const [width, setWidth] = useState<number>(defaultWidth);
  const { storageWidth, setAsideWidthStorage, onResize } = useResizer(defaultWidth, initialWidth);

  useIsomorphicLayoutEffect(() => {
    setWidth(storageWidth);
  }, [storageWidth]);

  return (
    <StyledResizableAside className="navigation-tree">
      <ResizableBox
        className="navigation-tree__resizable"
        width={width}
        height={defaultHeight}
        handle={<span className="navigation-tree__splitter" />}
        minConstraints={[defaultWidth]}
        maxConstraints={[maxWidth]}
        onResizeStop={setAsideWidthStorage}
        onResize={onResize}
      >
        {children}
      </ResizableBox>
    </StyledResizableAside>
  );
};
